// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__AUjhQ","header":"styles_header__lh98Z","left_align":"styles_left_align__mT5Gh","card_wrapper":"styles_card_wrapper__wCYJM"};